import { Image } from "@mantine/core";

export default function Logo({
  className,
  hideIhc = false,
}: {
  className?: string;
  hideIhc?: boolean;
}) {
  return (
    <div
      className={`inline-flex gap-2 ${
        hideIhc ? "justify-start" : "justify-around"
      } items-center w-full`}
    >
      <Image src="/logo/cirql-logo.svg" alt="logo" className={`${className}`} />
      {/**
      <Divider hidden={hideIhc} orientation="vertical" />
      <Image
        display={hideIhc ? "none" : "block"}
        src="/logo/logo-ihc.svg"
        alt="logo"
        className={className}
      />
      **/}
    </div>
  );
}
